import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import TablePagination from "@material-ui/core/TablePagination";
import TextField from "@material-ui/core/TextField";
import TestimonialsTable from "./testimonials.table";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Button } from "@material-ui/core";

import { Api } from "../utils/api";
import { useQuery } from "react-query";
import { Controller, useForm } from "react-hook-form";

import styles from "./styles.module.scss";

const rowsPerPage = 50;
const api = new Api();

const testimonialsType = (props) =>
  props.location.pathname.includes("professional")
    ? "professional"
    : "particular";

const List = (props) => {
  const [page, setPage] = useState(0);
  const [query, setQuery] = useState();

  // Queries
  const { handleSubmit, control } = useForm();

  const { data, error, isError, isLoading } = useQuery(
    ["testimonials", page, query, testimonialsType(props)],
    () => getTestimonials(page, query),
    { keepPreviousData: true }
  );

  useEffect(() => {
    setPage(0);
  }, [query]);

  const onSubmit = (query) => setQuery(query);

  const getTestimonials = async (page, query) => {
    const {
      data: { testimonials, count },
    } = await api.get("/testimonials", {
      ...query,
      type: testimonialsType(props),
      page: page + 1,
      rows: rowsPerPage,
    });
    return { testimonials, count };
  };

  if (isLoading) {
    return <CircularProgress color="primary" />;
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <Grid container>
      <Grid item xs={1}></Grid>

      <Grid item xs={10}>
        <Button
          color="primary"
          variant="contained"
          href={`/testimonials/${testimonialsType(props)}/new`}
        >
          Adicionar testemunho
        </Button>
      </Grid>
      <Grid container>
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <form onChange={handleSubmit(onSubmit)}>
            <Controller
              name={"search"}
              control={control}
              render={({ field: { onChange, value } }) => (
                <TextField
                  fullWidth
                  onChange={onChange}
                  value={value}
                  label={"Pesquisar por estado, nome, título ou testemunho..."}
                />
              )}
            />
          </form>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <TestimonialsTable
            type={testimonialsType(props)}
            testimonials={data.testimonials}
          ></TestimonialsTable>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <TablePagination
            rowsPerPageOptions={[]}
            count={data.count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, page) => setPage(page)}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default List;
